import axios from 'axios';

import { Id, getData } from '@feature/utils';

import { Mobility, MobilityRequest } from './MobilityTypes';

export function list(year?: number) {
  return axios
    .get<Mobility[]>('/travel/erasmus-mobilities', {
      params: { year },
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Mobility>(`/travel/erasmus-mobilities/${id}`).then(getData);
}

export function create(request: MobilityRequest) {
  return axios.post<Mobility>('/travel/erasmus-mobilities', request).then(getData);
}

export function update(id: Id, request: MobilityRequest) {
  return axios.put<Mobility>(`/travel/erasmus-mobilities/${id}`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/travel/erasmus-mobilities/${id}`).then(getData);
}

export function uploadCertificate(id: Id, file: File) {
  const formData = new FormData();
  formData.append('file', file);

  return axios
    .post<Mobility>(`/travel/erasmus-mobilities/${id}/certificate`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(getData);
}

export function downloadCertificate(id: Id) {
  return axios.get<Blob>(`/travel/erasmus-mobilities/${id}/certificate/download`, { responseType: 'blob' });
}

export function deleteCertificate(id: Id) {
  return axios.delete<Mobility>(`/travel/erasmus-mobilities/${id}/certificate`).then(getData);
}
